import styles from '../../styles/mainContent/Home.module.css';
import utilities from '../../styles/utilities.module.css';
import ResumeDownload from './ResumeDownload';
import { fullName, bio } from '../../data/personal';

const Home = () => {
  return (
    <section id="home" className={utilities.container}>
      <h1 className={styles.title}>{fullName}</h1>
        <div className={styles.subsection}>
          <h2>About Me</h2>
          <p className={styles.introText}>
          {bio}
          </p>
          <ResumeDownload />
        </div>
    </section>
  );
};

export default Home;